import { Node, mergeAttributes } from '@tiptap/core';
const MEDIA_ASSETS_ITEM_NODE_NAME = 'media-assets-item';
const MEDIA_ASSETS_ITEM_TAG_NAME = `mb-${MEDIA_ASSETS_ITEM_NODE_NAME}`;
const MEDIA_ASSETS_ITEM_NODE_DATA_ATTRIBUTE = `data-${MEDIA_ASSETS_ITEM_NODE_NAME}`;
export const MediaAssetsItem = Node.create({
    name: 'mediaAssetsItem',
    group: 'mediaAssets',
    atom: true,
    addAttributes() {
        return {
            userAssetUUID: {
                default: [],
                renderHTML(attrs) {
                    return {
                        [MEDIA_ASSETS_ITEM_NODE_DATA_ATTRIBUTE]: attrs.userAssetUUID,
                    };
                },
                parseHTML(element) {
                    return (element.getAttribute(MEDIA_ASSETS_ITEM_NODE_DATA_ATTRIBUTE) ?? '');
                },
            },
        };
    },
    addCommands() {
        return {
            addMediaAssetsItemBlock: (userAssetUUID) => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    attrs: {
                        userAssetUUID,
                    },
                });
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: MEDIA_ASSETS_ITEM_TAG_NAME,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [MEDIA_ASSETS_ITEM_TAG_NAME, mergeAttributes(HTMLAttributes)];
    },
});
const EXTENSION_NAME = 'mediaAssets';
const NODE_NAME = 'media-assets';
const TAG_NAME = `mb-${NODE_NAME}`;
export const MediaAssets = Node.create({
    name: EXTENSION_NAME,
    group: 'block',
    content: `${MediaAssetsItem.name}+`,
    draggable: true,
    atom: true,
    addOptions() {
        return {
            ...this.parent?.(),
        };
    },
    addCommands() {
        return {
            addMediaAssetsBlock: (userAssetUUIDs) => ({ commands }) => {
                return commands.insertContent({
                    type: this.name,
                    content: userAssetUUIDs.map((userAssetUUID) => ({
                        type: 'mediaAssetsItem',
                        attrs: { userAssetUUID },
                    })),
                });
            },
            showMediaUploader: () => () => {
                this.options.showMediaUploader();
                return true;
            },
        };
    },
    parseHTML() {
        return [
            {
                tag: TAG_NAME,
            },
        ];
    },
    renderHTML({ HTMLAttributes }) {
        return [TAG_NAME, mergeAttributes(HTMLAttributes)];
    },
});
//# sourceMappingURL=media-assets.js.map